import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import apiRequest from '@utils/apiRequest'
import { onDownloadFile } from '@utils/download'

export const adminGetBoardContentList = createAsyncThunk(
  'ADMIN_GET_BOARD_CONTENT_LIST',
  async ({boardId}) => {
    let options = {
      method: 'GET',
      url: `${process.env.REACT_APP_AP_ADMIN_SERVER_HOST}/board/${boardId}/content`
    }
    let response = await apiRequest(options)
    if (response.__isError) { return }
    return response
  }
)

export const adminCreateBoardContent = createAsyncThunk(
  'ADMIN_CREATE_BOARD_CONTENT',
  async ({data, boardId}) => {
    let options = {
      method: 'POST',
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      url: `${process.env.REACT_APP_AP_ADMIN_SERVER_HOST}/board/${boardId}/content`,
      data
    }
    let response = await apiRequest(options)
    if (response.__isError) { return }
    return true
  }
)

export const adminUpdateBoardContent = createAsyncThunk(
  'ADMIN_UPDATE_BOARD_CONTENT',
  async ({data, contentId}) => {
    let options = {
      method: 'PUT',
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      url: `${process.env.REACT_APP_AP_ADMIN_SERVER_HOST}/board/content/${contentId}`,
      data
    }
    let response = await apiRequest(options)
    if (response.__isError) { return }
    return true
  }
)

export const adminDeleteBoardContent = createAsyncThunk(
  'ADMIN_DELETE_BOARD_CONTENT',
  async ({contentId}) => {
    let options = {
      method: 'DELETE',
      url: `${process.env.REACT_APP_AP_ADMIN_SERVER_HOST}/board/content/${contentId}`,
    }
    let response = await apiRequest(options)
    if (response.__isError) { return }
    return true
  }
)

export const adminDownloadBoardAttach = createAsyncThunk(
  'ADMIN_DOWNLOAD_BOARD_ATTACH',
  async ({name, attachId}) => {
    let options = {
      method: 'GET',
      url: `${process.env.REACT_APP_AP_ADMIN_SERVER_HOST}/board/attach/${attachId}`,
      responseType: 'blob',
    }
    let response = await apiRequest(options)
    if (response.__isError) {
      return
    }
    return {
      fileName: name,
      data: response
    }
  }
)

const adminBoardContentSlice = createSlice({
  name: 'adminBoardContent',
  initialState: {
    boardContentList: [],
  },
  reducers: {
    adminClearBoardContentList: (state) => {
      state.boardContentList = []
    },
  },
  extraReducers: {
    [adminGetBoardContentList.fulfilled]: (state, { payload }) => {
      state.isLoading = false
      state.boardContentList = payload
    },
    [adminDownloadBoardAttach.fulfilled]: (state, { payload }) => {
      if (!payload) {
        return
      }

      const url = window.URL.createObjectURL(new Blob([payload.data]))
      const fileName = payload.fileName

      onDownloadFile({url, fileName})
    },
  }
})

export const { adminClearBoardContentList } = adminBoardContentSlice.actions

export default adminBoardContentSlice.reducer